import { useAuth } from '~/hooks';

const DASHBOARD_URL = process.env.NEXT_PUBLIC_DASHBOARD_URL?.trim();

function DashboardAccess() {
  const { accessToken } = useAuth();

  if (!DASHBOARD_URL) return null;

  const goToDashboard = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();

    try {
      const url = new URL(DASHBOARD_URL);
      if (accessToken) url.searchParams.set('token', accessToken);
      window.location.assign(url.toString());
    } catch {
      window.location.assign(DASHBOARD_URL);
    }
  };

  return (
    <a
      href={DASHBOARD_URL}
      className="dashboard-access"
      title="Ir al Dashboard"
      aria-label="Ir al Dashboard"
      onClick={goToDashboard}
    >
      <i className="d-icon-mode-grid" aria-hidden="true"></i>
      <span>Dashboard</span>
    </a>
  );
}

export default DashboardAccess;
